// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/atmospheric-layers.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/atmospheric-layers/atmospheric-layers.js';

mount([g0]);
